import { render, staticRenderFns } from "./information.vue?vue&type=template&id=38a47320&scoped=true&"
import script from "./information.vue?vue&type=script&lang=ts&"
export * from "./information.vue?vue&type=script&lang=ts&"
import style0 from "./information.vue?vue&type=style&index=0&id=38a47320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a47320",
  null
  
)

export default component.exports